import fetchAPI from '../fetchUtils';

const contactFormAPI = {
  createCustomer: async (body) =>
    fetchAPI.postAnonymous('/create-form-customer', body, 'application/json'),
};

export default contactFormAPI;
